"use client";

import type { ReactNode, RefObject } from "react";
import { IconClose } from "./icons";

// Modal / alt sayfa (bottom sheet): yerel <dialog> + showModal() → odak tuzağı, Esc ile kapanma, arka planın
// erişilemezliği tarayıcıdan gelir; kapanınca odak açan düğmeye döner. Dışına tıklamak kapatır.
//  side="bottom": mobil filtre paneli (alttan, en fazla %92 yükseklik, yapışkan alt eylem çubuğu)
//  side="right":  mobil menü (sağdan çekmece)
export function Sheet({
  dialogRef,
  titleId,
  title,
  closeLabel,
  side = "bottom",
  footer,
  children,
  label,
}: {
  dialogRef: RefObject<HTMLDialogElement | null>;
  /** Görünür başlık (aria-labelledby) */
  title: ReactNode;
  titleId: string;
  closeLabel: string;
  side?: "bottom" | "right";
  footer?: ReactNode;
  children: ReactNode;
  /** Başlık yerine ad (aria-label) */
  label?: string;
}) {
  const position =
    side === "bottom"
      ? "m-0 mt-auto h-auto max-h-[92dvh] w-full max-w-none rounded-t-xl motion-safe:open:animate-sheet-in"
      : "m-0 ml-auto h-dvh max-h-dvh w-[min(24rem,100vw)] max-w-none motion-safe:open:animate-drawer-in";
  return (
    <dialog
      ref={dialogRef}
      {...(label ? { "aria-label": label } : { "aria-labelledby": titleId })}
      className={`${position} overflow-hidden bg-surface p-0 text-ink shadow-raised`}
      onClick={(e) => {
        if (e.target === dialogRef.current) dialogRef.current.close();
      }}
    >
      <div className={`flex flex-col ${side === "bottom" ? "max-h-[92dvh]" : "h-full"}`}>
        {side === "bottom" && <span aria-hidden="true" className="mx-auto mt-2.5 h-1.5 w-12 shrink-0 rounded-full bg-line-strong/60" />}
        <div className="flex shrink-0 items-center justify-between border-b border-line px-4 py-2.5">
          <h2 id={titleId} className="font-heading text-lg font-semibold text-ink">
            {title}
          </h2>
          <button
            type="button"
            onClick={() => dialogRef.current?.close()}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full text-ink hover:bg-primary-soft"
          >
            <IconClose size={22} />
            <span className="sr-only">{closeLabel}</span>
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">{children}</div>
        {footer && <div className="shrink-0 border-t border-line bg-surface px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">{footer}</div>}
      </div>
    </dialog>
  );
}
